import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 63A41E0F-CCDB-42F8-848B-F64AA94F9BDF
 * name disc-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/disc-alert.svg
 * tags
 * - Alert / Error 
 */
export const DiscAlertIcon = createSvgIcon(<><path d="M10 14C8.9 14 8 13.1 8 12C8 10.9 8.9 10 10 10C11.1 10 12 10.9 12 12S11.1 14 10 14M10 4C5.6 4 2 7.6 2 12S5.6 20 10 20 18 16.4 18 12 14.4 4 10 4M20 13H22V7H20M20 17H22V15H20V17Z" /></>, 'DiscAlertIcon');
export default DiscAlertIcon